import { TableOfContent } from '../../typings/interfaces';
import ARTableOfContent from './tableOfContent/Arabic';
import SCTableOfContent from './tableOfContent/ChineseSimplified';
import NLTableOfContent from './tableOfContent/Dutch';
import ENTableOfContent from './tableOfContent/English';
import FRTableOfContent from './tableOfContent/French';
import ESLTableOfContent from './tableOfContent/LatinSpanish';
import DETableOfContent from './tableOfContent/German';
import HITableOfContent from './tableOfContent/Hindi';
import HUTableOfContent from './tableOfContent/Hungarian';
import IDTableOfContent from './tableOfContent/Indonesian';
import ITTableOfContent from './tableOfContent/Italian';
import KNTableOfContent from './tableOfContent/Kannada';
import KOTableOfContent from './tableOfContent/Korean';
import NDTableOfContent from './tableOfContent/Norwegian';
import PLTableOfContent from './tableOfContent/Polish';
import PTTableOfContent from './tableOfContent/Portuguese';
import ROTableOfContent from './tableOfContent/Romania';
import RUTableOfContent from './tableOfContent/Russian';
import ESTableOfContent from './tableOfContent/SpanishSpain';
import TETableOfContent from './tableOfContent/TeluguIndia';
import THTableOfContent from './tableOfContent/Thai';
import TRTableofContent from './tableOfContent/Turkish';
import VITableOfContent from './tableOfContent/Vietnamese';

const tableOfContent: TableOfContent[] = [
  ENTableOfContent,
  ARTableOfContent,
  SCTableOfContent,
  NLTableOfContent,
  FRTableOfContent,
  ESLTableOfContent,
  DETableOfContent,
  HITableOfContent,
  HUTableOfContent,
  IDTableOfContent,
  ITTableOfContent,
  KNTableOfContent,
  KOTableOfContent,
  NDTableOfContent,
  PLTableOfContent,
  PTTableOfContent,
  ROTableOfContent,
  RUTableOfContent,
  ESTableOfContent,
  TETableOfContent,
  THTableOfContent,
  TRTableofContent,
  VITableOfContent,
];

export default tableOfContent;
